import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'
import PageContainer from '@/components/page-container'
import RoleManagementForm from '@/routes/admin/management/roles/-components/role-management-form'
import $api from '@/services/api'

export const Route = createFileRoute('/admin/management/roles/create')({
  component: CreateRoleManagement,
  staticData: {
    breadcrumb: 'Add New Role',
  },
})

function CreateRoleManagement() {
  const navigate = Route.useNavigate()
  const queryClient = useQueryClient()
  const mutation = $api.useMutation('post', '/roles', {
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: $api.queryOptions('get', '/roles').queryKey,
      })
      toast.success('Role created successfully')
      navigate({ to: `..`, replace: true })
    },
  })
  return (
    <PageContainer title="Add New Role" backUrl="/admin/management/roles">
      <RoleManagementForm
        onSubmit={async (values) =>
          await mutation.mutateAsync({
            body: {
              name: values.name,
              permissionJson: values.permissions as never,
            },
          })
        }
      />
    </PageContainer>
  )
}
